import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CompanyProvider } from './context/CompanyContext';
import { NotificationProvider } from './context/NotificationContext';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import PrivateRoute from './components/Auth/PrivateRoute';
import DashboardLayout from './components/Layout/DashboardLayout';
import Login from './components/Auth/Login';
import Dashboard from './pages/Dashboard';
import Categories from './pages/Categories';
import Brands from './pages/Brands';
import Products from './pages/Products';
import Orders from './pages/Orders';
import Clients from './pages/Clients';
import Quotes from './pages/Quotes';
import Warranties from './pages/Warranties';
import StockMovements from './pages/StockMovements';
import Sliders from './pages/Sliders';
import SitesVitrines from './pages/SitesVitrines';
import PromoPacks from './pages/PromoPacks';
import Coupons from './pages/Coupons';
import Users from './pages/Users';
import Analytics from './pages/Analytics';
import CompanySettings from './pages/CompanySettings';
import AboutPageContent from './pages/AboutPageContent';
import B2BPageContent from './pages/B2BPageContent';
import POS from './pages/POS';
import Sales from './pages/Sales';
import WarrantyVerification from './pages/WarrantyVerification';
import Contacts from './pages/Contacts';
import NewsletterSubscribers from './pages/NewsletterSubscribers';
import Reviews from './pages/Reviews';
import Inquiries from './pages/Inquiries';
import Shipments from './pages/Shipments';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import NotFound from './pages/errors/NotFound';
import Forbidden from './pages/errors/Forbidden';
import ServerError from './pages/errors/ServerError';
import ServiceUnavailable from './pages/errors/ServiceUnavailable';


function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <CompanyProvider>
          <NotificationProvider>
            <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-warranty" element={<WarrantyVerification />} />

              {/* Error pages */}
              <Route path="/403" element={<Forbidden />} />
              <Route path="/404" element={<NotFound />} />
              <Route path="/500" element={<ServerError />} />
              <Route path="/503" element={<ServiceUnavailable />} />

          <Route
            path="/"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <Dashboard />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/categories"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <Categories />
                </DashboardLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/brands"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <Brands />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/products"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <Products />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/orders"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <Orders />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/clients"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <Clients />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/quotes"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <Quotes />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/warranties"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <Warranties />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/stock-movements"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <StockMovements />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/sliders"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <Sliders />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/sites-vitrines"
            element={
              <PrivateRoute adminOnly>
                <DashboardLayout>
                  <SitesVitrines />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/promo-packs"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <PromoPacks />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/coupons"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <Coupons />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/company-settings"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <CompanySettings />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/page-about"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <AboutPageContent />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/page-b2b"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <B2BPageContent />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/pos"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <POS />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/sales"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <Sales />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/contacts"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <Contacts />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/newsletter"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <NewsletterSubscribers />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/reviews"
            element={
              <PrivateRoute adminOnly>
                <DashboardLayout>
                  <Reviews />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/inquiries"
            element={
              <PrivateRoute adminOnly>
                <DashboardLayout>
                  <Inquiries />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/shipments"
            element={
              <PrivateRoute>
                <DashboardLayout>
                  <Shipments />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/users"
            element={
              <PrivateRoute adminOnly>
                <DashboardLayout>
                  <Users />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/analytics"
            element={
              <PrivateRoute adminOnly>
                <DashboardLayout>
                  <Analytics />
                </DashboardLayout>
              </PrivateRoute>
            }
          />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </Router>
          </NotificationProvider>
        </CompanyProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
